<template>
    <main class="app">
        <router-view />

        <apple-add-to-home-screen-modal
            v-if="showAddToHomeScreenModalForApple"
            class="apple-add-to-home-screen-modal"
            @close="closeAddToHomeScreenModalForApple(false)"
        />
    </main>
</template>

<script>
import AppleAddToHomeScreenModal          from "@/components/AppleAddToHomeScreenModal";
import {mapState, mapActions, mapGetters} from "vuex";

export default {
    name      : "PublicLayout",
    components: {
        AppleAddToHomeScreenModal
    },
    computed  : {
        ...mapState(
            "app",
            [
                "showAddToHomeScreenModalForApple"
            ]
        )
    },
    methods   : {
        ...mapActions(
            "app",
            [
                "closeAddToHomeScreenModalForApple"
            ]
        ),
        ...mapGetters("authentication", ["isUserLoggedIn"])
    }
};
</script>

<style lang="scss">
body {
    margin   : 0;
    overflow : hidden;

    .app {
        min-height : 100vh;
        min-width  : 100%;
        display    : flex;
        justify-content: center;
    }
}
</style>